export default "__VITE_ASSET__DRzK6GM3__"